webpackJsonp([8],{

/***/ 450:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_japisale_planes_vue__ = __webpack_require__(774);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fd35eab2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_japisale_planes_vue__ = __webpack_require__(975);
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_japisale_planes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fd35eab2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_japisale_planes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 467:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


function data() {
	return {
		linkAppRunn: 'https://fenixcorp.net/'
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'app-footer',
	data: data,
	props: {
		isJapi: {
			type: Boolean,
			default: false
		}
	}
});

/***/ }),

/***/ 468:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


function data() {
	return {
		countries: [{
			name: 'Perú',
			city: 'Lima',
			phones: [( true ? 'undefined' + ' </br>' : '') + '\n\t\t\t\t\tCalle Independencia  106,</br>  \n\t\t\t\t\tPiso 10 Miraflores']
		}, {
			name: 'Ecuador',
			city: 'Latacunga',
			phones: ['PBX(03) 3730500 - +593 998514801' + '</br>\n\t\t\t\t\tAV.UNIDAD NACIONAL Y GABRIELA MISTRAL. EDIF FENIX CORP</br>\n\t\t\t\t\tMatriz Centro Tecnol\xF3gico Latacunga']
		}],
		linkInstagram: 'undefined',
		linkYoutube: 'undefined',
		linkFb: 'undefined',
		linkInstagramJapi: 'undefined',
		linkYoutubeJapi: 'undefined',
		linkFbJapi: 'undefined'
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'company-data',
	data: data,
	props: {
		isJapi: {
			type: Boolean,
			default: false
		}
	}
});

/***/ }),

/***/ 501:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_footer_vue__ = __webpack_require__(467);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_619284ef_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_footer_vue__ = __webpack_require__(504);
function injectStyle (ssrContext) {
  __webpack_require__(502)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-619284ef"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_619284ef_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 502:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(503);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(439)("47db253e", content, true, {});

/***/ }),

/***/ 503:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(438)(true);
// imports


// module
exports.push([module.i, ".app-footer[data-v-619284ef]{background:#494949;color:#fff;line-height:24px;padding:70px 5%}@media (max-width:900px){.app-footer[data-v-619284ef]{padding:30px 3%}}.app-footer img[data-v-619284ef]{max-width:100%}.text-right[data-v-619284ef]{text-align:right}.title-footer[data-v-619284ef]{font-size:20px;line-height:30px;text-transform:uppercase}@media (max-width:900px){.title-footer[data-v-619284ef]{text-align:center}}.pa-16-desktop[data-v-619284ef]{padding:0 16px}.wrapper-text[data-v-619284ef]{font-size:16px}.btn-link[data-v-619284ef]{border-radius:8px;color:#fff;display:inline-block;padding:15px 60px;text-align:center;text-decoration:none;text-transform:uppercase;width:100%}.btn-blue[data-v-619284ef]{background-color:#005398}.btn-green[data-v-619284ef]{background-color:#02979b}.btn-mobile[data-v-619284ef]{display:none}@media (max-width:900px){.btn-mobile[data-v-619284ef]{display:block}}@media (max-width:900px){.btn-desktop[data-v-619284ef]{display:none}}@media (max-width:900px){.wrapper-logos[data-v-619284ef]{margin-bottom:45px}}.pa-20-desktop[data-v-619284ef]{padding-right:20%}@media (max-width:900px){.pa-20-desktop[data-v-619284ef]{padding-right:0}}", "", {"version":3,"sources":["/opt/build/repo/src/components/home-new/app-footer.vue"],"names":[],"mappings":"AACA,6BACE,mBAAoB,AACpB,WAAe,AACf,iBAAkB,AAClB,eAAiB,CAClB,AACD,yBACA,6BACM,eAAiB,CACtB,CACA,AACD,iCACI,cAAgB,CACnB,AACD,6BACE,gBAAkB,CACnB,AACD,+BACE,eAAgB,AAChB,iBAAkB,AAClB,wBAA0B,CAC3B,AACD,yBACA,+BACM,iBAAmB,CACxB,CACA,AACD,gCACE,cAAgB,CACjB,AACD,+BACE,cAAgB,CACjB,AACD,2BACE,kBAAmB,AACnB,WAAe,AACf,qBAAsB,AACtB,kBAAmB,AACnB,kBAAmB,AACnB,qBAAsB,AACtB,yBAA0B,AAC1B,UAAY,CACb,AACD,2BACE,wBAA0B,CAC3B,AACD,4BACE,wBAA0B,CAC3B,AACD,6BACE,YAAc,CACf,AACD,yBACA,6BACM,aAAe,CACpB,CACA,AACD,yBACA,8BACI,YAAc,CACjB,CACA,AACD,yBACA,gCACI,kBAAoB,CACvB,CACA,AACD,gCACE,iBAAmB,CACpB,AACD,yBACA,gCACM,eAAiB,CACtB,CACA","file":"app-footer.vue","sourcesContent":["\n.app-footer[data-v-619284ef] {\n  background: #494949;\n  color: #ffffff;\n  line-height: 24px;\n  padding: 70px 5%;\n}\n@media (max-width: 900px) {\n.app-footer[data-v-619284ef] {\n      padding: 30px 3%;\n}\n}\n.app-footer img[data-v-619284ef] {\n    max-width: 100%;\n}\n.text-right[data-v-619284ef] {\n  text-align: right;\n}\n.title-footer[data-v-619284ef] {\n  font-size: 20px;\n  line-height: 30px;\n  text-transform: uppercase;\n}\n@media (max-width: 900px) {\n.title-footer[data-v-619284ef] {\n      text-align: center;\n}\n}\n.pa-16-desktop[data-v-619284ef] {\n  padding: 0 16px;\n}\n.wrapper-text[data-v-619284ef] {\n  font-size: 16px;\n}\n.btn-link[data-v-619284ef] {\n  border-radius: 8px;\n  color: #ffffff;\n  display: inline-block;\n  padding: 15px 60px;\n  text-align: center;\n  text-decoration: none;\n  text-transform: uppercase;\n  width: 100%;\n}\n.btn-blue[data-v-619284ef] {\n  background-color: #005398;\n}\n.btn-green[data-v-619284ef] {\n  background-color: #02979b;\n}\n.btn-mobile[data-v-619284ef] {\n  display: none;\n}\n@media (max-width: 900px) {\n.btn-mobile[data-v-619284ef] {\n      display: block;\n}\n}\n@media (max-width: 900px) {\n.btn-desktop[data-v-619284ef] {\n    display: none;\n}\n}\n@media (max-width: 900px) {\n.wrapper-logos[data-v-619284ef] {\n    margin-bottom: 45px;\n}\n}\n.pa-20-desktop[data-v-619284ef] {\n  padding-right: 20%;\n}\n@media (max-width: 900px) {\n.pa-20-desktop[data-v-619284ef] {\n      padding-right: 0;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 504:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-footer"},[_c('v-layout',{staticClass:"container",attrs:{"wrap":"","justify-center":""}},[_c('v-flex',{staticClass:"wrapper-logos",attrs:{"xs12":"","md6":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","mb-3":""}},[(!_vm.isJapi)?_c('h2',{staticClass:"w-black title-footer pa-16-desktop"},[_vm._v("CASA MARKET llega gracias a Apprunn")]):_c('h2',{staticClass:"w-black title-footer pa-16-desktop"},[_vm._v("JAPISALE llega gracias a Apprunn")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('p',{staticClass:"w-black pa-16-desktop"},[_vm._v("Nuestros productos y  principales clientes/partnes:")])]),_vm._v(" "),_c('v-layout',{staticClass:"pa-20-desktop",attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs6":"","pa-2":""}},[_c('a',{attrs:{"href":"https://feedbackinn.com/","target":"_blank"}},[_c('img',{attrs:{"src":"/static/images-new/logos/logo-feedbackinn.png","alt":"feedbackinn","height":"28"}})])]),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","pa-2":""}},[_c('a',{attrs:{"href":"https://makipos.la/","target":"_blank"}},[_c('img',{attrs:{"src":"/static/images-new/logos/logo-makipos.png","alt":"makipos","height":"28"}})])]),_vm._v(" "),_c('v-flex',{staticClass:"text-right",class:[_vm.isJapi ? 'xs6' : 'xs4'],attrs:{"pa-2":""}},[_c('a',{attrs:{"href":"https://fenixcorp.net/","target":"_blank"}},[_c('img',{attrs:{"src":"/static/images-new/logos/logo-fenix.png","alt":"fenix","height":"28"}})])]),_vm._v(" "),(!_vm.isJapi)?_c('v-flex',{staticClass:"text-right",attrs:{"xs4":"","pa-2":""}},[_c('a',{attrs:{"href":"https://japisale.com/","target":"_blank"}},[_c('img',{attrs:{"src":"/static/images-new/logos/logo-japisale.png","alt":"japisale","height":"28"}})])]):_vm._e(),_vm._v(" "),_c('v-flex',{staticClass:"text-right",class:[_vm.isJapi ? 'xs6' : 'xs4'],attrs:{"pa-2":""}},[(_vm.isJapi)?_c('a',{attrs:{"href":"https://casamarket.la/","target":"_blank"}},[_c('img',{attrs:{"src":"/static/images-new/logos/casa-market.svg","alt":"praktiko","height":"28"}})]):_c('img',{attrs:{"src":"/static/images-new/logos/logo-praktiko.png","alt":"praktiko","height":"28"}})])],1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"wrapper-text",attrs:{"xs12":"","md4":""}},[_c('p',[_vm._v("Apprun es un Product Studio que tiene como misión \n\t\t\t\tcrear productos que ayuden a mejorar la vida de la gente .\n\t\t\t")]),_vm._v(" "),_c('v-flex',{staticClass:"btn-desktop",attrs:{"xs12":"","mt-5":"","pl-2":""}},[_c('a',{staticClass:"btn-link",class:[_vm.isJapi ? 'btn-blue' : 'btn-green'],attrs:{"href":_vm.linkAppRunn,"target":"_blank"}},[_vm._v("Visita Apprunn.com")])])],1),_vm._v(" "),_c('v-flex',{staticClass:"btn-mobile",attrs:{"xs12":"","mt-3":"","text-xs-center":""}},[_c('a',{staticClass:"btn-link",class:[_vm.isJapi ? 'btn-blue' : 'btn-green'],attrs:{"href":_vm.linkAppRunn,"target":"_blank"}},[_vm._v("Visita Apprunn.com")])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 505:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_company_data_vue__ = __webpack_require__(468);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38943509_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_company_data_vue__ = __webpack_require__(508);
function injectStyle (ssrContext) {
  __webpack_require__(506)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-38943509"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_company_data_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38943509_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_company_data_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 506:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(507);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(439)("78e1330a", content, true, {});

/***/ }),

/***/ 507:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(438)(true);
// imports


// module
exports.push([module.i, ".company-data[data-v-38943509]{color:#494949;font-size:16px;padding:98px 5%}@media (max-width:900px){.company-data[data-v-38943509]{padding:71px 53px 25px}}.title[data-v-38943509]{color:#ff6e1c;font-size:24px}.title-japi[data-v-38943509]{color:#005398;font-size:24px}.list-company[data-v-38943509]{list-style:none}.link-social-networks[data-v-38943509]{color:#494949;text-decoration:none}@media (max-width:900px){.logo[data-v-38943509]{height:57px;max-width:100%}}@media (max-width:900px){.wrapper-information[data-v-38943509]{margin-top:48px}}@media (max-width:900px){.text-information[data-v-38943509]{margin-bottom:43px}}", "", {"version":3,"sources":["/opt/build/repo/src/components/home-new/company-data.vue"],"names":[],"mappings":"AACA,+BACE,cAAe,AACf,eAAgB,AAChB,eAAiB,CAClB,AACD,yBACA,+BACM,sBAA6B,CAClC,CACA,AACD,wBACE,cAAe,AACf,cAAgB,CACjB,AACD,6BACE,cAAe,AACf,cAAgB,CACjB,AACD,+BACE,eAAiB,CAClB,AACD,uCACE,cAAe,AACf,oBAAsB,CACvB,AACD,yBACA,uBACI,YAAa,AACb,cAAgB,CACnB,CACA,AACD,yBACA,sCACI,eAAiB,CACpB,CACA,AACD,yBACA,mCACI,kBAAoB,CACvB,CACA","file":"company-data.vue","sourcesContent":["\n.company-data[data-v-38943509] {\n  color: #494949;\n  font-size: 16px;\n  padding: 98px 5%;\n}\n@media (max-width: 900px) {\n.company-data[data-v-38943509] {\n      padding: 71px 53px 25px 53px;\n}\n}\n.title[data-v-38943509] {\n  color: #ff6e1c;\n  font-size: 24px;\n}\n.title-japi[data-v-38943509] {\n  color: #005398;\n  font-size: 24px;\n}\n.list-company[data-v-38943509] {\n  list-style: none;\n}\n.link-social-networks[data-v-38943509] {\n  color: #494949;\n  text-decoration: none;\n}\n@media (max-width: 900px) {\n.logo[data-v-38943509] {\n    height: 57px;\n    max-width: 100%;\n}\n}\n@media (max-width: 900px) {\n.wrapper-information[data-v-38943509] {\n    margin-top: 48px;\n}\n}\n@media (max-width: 900px) {\n.text-information[data-v-38943509] {\n    margin-bottom: 43px;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 508:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"container company-data",attrs:{"wrap":""}},[_c('v-flex',{attrs:{"md5":"","xs12":""}},[_c('div',{staticClass:"mb-5"},[_c('a',{attrs:{"href":""}},[(_vm.isJapi)?_c('img',{staticClass:"logo",attrs:{"src":"/static/images-new/sections/logo-japi.svg","alt":"CasaMarket"}}):_c('img',{staticClass:"logo",attrs:{"src":"/static/images-new/logos/logo-casamarket.svg","alt":"CasaMarket"}})])]),_vm._v(" "),_c('div',{staticClass:"layout"},[(!_vm.isJapi)?_c('a',{staticClass:"mr-3",attrs:{"href":_vm.isJapi ? _vm.linkInstagramJapi : _vm.linkInstagram,"target":"_blank"}},[_c('img',{attrs:{"src":"/static/images-new/logos/logo-instagram.svg","alt":"instagram"}})]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"mr-3",attrs:{"href":_vm.isJapi ? _vm.linkYoutubeJapi : _vm.linkYoutube,"target":"_blank"}},[_c('img',{attrs:{"src":"/static/images-new/logos/logo-youtube.svg","alt":"youtube"}})]),_vm._v(" "),_c('a',{staticClass:"mr-3",attrs:{"href":_vm.isJapi ? _vm.linkFbJapi : _vm.linkFb,"target":"_blank"}},[_c('img',{attrs:{"src":"/static/images-new/logos/logo-facebook.svg","alt":"facebook"}})])])]),_vm._v(" "),_c('v-flex',{staticClass:"wrapper-information",attrs:{"md7":"","xs12":""}},[_c('v-layout',{attrs:{"wrap":""}},[(!_vm.isJapi)?_c('v-flex',{staticClass:"text-information",attrs:{"md4":"","xs12":"","pr-3":""}},[_c('p',{staticClass:"title w-bold"},[_vm._v("Empresa")]),_vm._v(" "),_c('ul',{staticClass:"list-company"},[_c('li',{staticClass:"mb-2"},[_c('a',{staticClass:"link-social-networks",attrs:{"href":"/market-place","target":"_blank"}},[_vm._v("Quiero comprar")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"link-social-networks",attrs:{"href":"https://quierovender.casamarket.la/","target":"_blank"}},[_vm._v("Quiero vender")])])])]):_vm._e(),_vm._v(" "),_vm._l((_vm.countries),function(country){return _c('v-flex',{key:country.name,staticClass:"text-information",attrs:{"md4":"","xs12":"","pr-3":""}},[_c('p',{staticClass:"w-bold",class:[ _vm.isJapi ? 'title-japi' : 'title']},[_vm._v("\n\t\t\t\t\t"+_vm._s(country.name)+"\n\t\t\t\t")]),_vm._v(" "),_c('p',{staticClass:"mb-0 w-bold mb-2"},[_vm._v(_vm._s(country.city))]),_vm._v(" "),_c('div',_vm._l((country.phones),function(phone){return _c('div',{key:phone,domProps:{"innerHTML":_vm._s(phone)}})}))])})],2)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 774:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_japi_sale_section_plan__ = __webpack_require__(971);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_home_new_company_data__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_home_new_app_footer__ = __webpack_require__(501);
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'page-japisales-planes',
	components: {
		sectionPlan: __WEBPACK_IMPORTED_MODULE_0__components_japi_sale_section_plan__["a" /* default */],
		companyData: __WEBPACK_IMPORTED_MODULE_1__components_home_new_company_data__["a" /* default */],
		appFooter: __WEBPACK_IMPORTED_MODULE_2__components_home_new_app_footer__["a" /* default */]
	}
});

/***/ }),

/***/ 775:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

function whatsappLink() {
	var reg = /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i;
	if (reg.test(navigator.userAgent)) {
		return 'https://api.whatsapp.com/send?phone=' + '+593984000466';
	}
	return 'https://web.whatsapp.com/send?phone=' + '+593984000466';
}

function data() {
	return {
		items: [{
			id: 1,
			name: 'PLAN DESEGUE',
			price: 'Desde S/35 al mes',
			subtitle: 'Primer paso para iniciar tu viaje digital:',
			list: ['Tienda Online que te permite recibir pedidos por WhatsApp', 'Facturación Electrónica', 'Medios de Pago Online']
		}, {
			id: 2,
			name: 'PLAN EMPRENDEDOR',
			price: 'Desde S/75 al mes',
			subtitle: 'Segundo Paso, para escalar tu empresa:',
			list: ['500 Productos en tu catálogo', 'Tienda Online con Facebook Live', 'SEO', 'Control de Stock y Kardex', '2 Tiendas Físicas', 'Cupones de descuento']
		}, {
			id: 3,
			name: 'PLAN PRO',
			price: 'Desde S/149 al mes',
			subtitle: 'Tercer Paso, da el salto al mundo de las ventas por mobile:',
			list: ['App de Pedidos Personalizada', 'Ecommerce Web', 'Reseñas de clientes', 'Módulo de Caja y Tesorería', 'Rutas de Distribución para Delivery']
		}]
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	data: data,
	name: 'section-plan',
	computed: {
		whatsappLink: whatsappLink
	}
});

/***/ }),

/***/ 971:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_section_plan_vue__ = __webpack_require__(775);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2429f830_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_section_plan_vue__ = __webpack_require__(974);
function injectStyle (ssrContext) {
  __webpack_require__(972)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2429f830"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_section_plan_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2429f830_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_section_plan_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 972:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(973);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(439)("24d0975c", content, true, {});

/***/ }),

/***/ 973:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(438)(true);
// imports


// module
exports.push([module.i, ".section-plan[data-v-2429f830]{background-image:linear-gradient(180deg,#e7f0f4,#f8fbfc 68%);font-size:18px;padding:130px 4% 60px}@media (max-width:936px){.section-plan[data-v-2429f830]{padding:45px 4%}}.bold[data-v-2429f830]{font-weight:700}.text-blue[data-v-2429f830]{color:#005398}.subtitle[data-v-2429f830]{color:#494949;font-size:16px;padding:0 20%;text-align:center}@media (max-width:936px){.subtitle[data-v-2429f830]{padding:0 4%}}.group-title[data-v-2429f830]{border:2px solid #005398;border-radius:15px;color:#005398;padding:15px 0;text-align:center;margin:0 auto;width:85%}@media (max-width:936px){.group-title[data-v-2429f830]{margin:0 auto 17px;width:60%}}.f-14[data-v-2429f830]{font-size:14px}.text-price[data-v-2429f830]{color:#f3b951}.group-text[data-v-2429f830]{background-color:#fff;border:3px solid #f2f6f7;border-radius:12px;font-size:14px;height:calc(100% - 100px);padding:19px}@media (max-width:936px){.group-text[data-v-2429f830]{margin:0 auto;width:80%}}.text-number[data-v-2429f830]{align-items:center;background-color:#005398;border-radius:50%;color:#fff;display:flex;font-size:24px;font-weight:700;justify-content:center;height:58px;margin:0 auto;width:58px}.href-wssp[data-v-2429f830]{background:#64b161;border-radius:26px;box-shadow:0 2px 6px 0 hsla(0,0%,62%,.5);color:#fff;padding:9px 9px 9px 22px;text-decoration:none;width:282px}@media (max-width:936px){.group-arrow[data-v-2429f830]{display:none}}", "", {"version":3,"sources":["/opt/build/repo/src/components/japi-sale/section-plan.vue"],"names":[],"mappings":"AACA,+BACE,6DAAmE,AACnE,eAAgB,AAChB,qBAAuB,CACxB,AACD,yBACA,+BACM,eAAiB,CACtB,CACA,AACD,uBACE,eAAiB,CAClB,AACD,4BACE,aAAe,CAChB,AACD,2BACE,cAAe,AACf,eAAgB,AAChB,cAAe,AACf,iBAAmB,CACpB,AACD,yBACA,2BACM,YAAc,CACnB,CACA,AACD,8BACE,yBAA0B,AAC1B,mBAAoB,AACpB,cAAe,AACf,eAAgB,AAChB,kBAAmB,AACnB,cAAe,AACf,SAAW,CACZ,AACD,yBACA,8BACM,mBAAyB,AACzB,SAAW,CAChB,CACA,AACD,uBACE,cAAgB,CACjB,AACD,6BACE,aAAe,CAChB,AACD,6BACE,sBAA0B,AAC1B,yBAA0B,AAC1B,mBAAoB,AACpB,eAAgB,AAChB,0BAA2B,AAC3B,YAAc,CACf,AACD,yBACA,6BACM,cAAe,AACf,SAAW,CAChB,CACA,AACD,8BACE,mBAAoB,AACpB,yBAA0B,AAC1B,kBAAmB,AACnB,WAAe,AACf,aAAc,AACd,eAAgB,AAChB,gBAAiB,AACjB,uBAAwB,AACxB,YAAa,AACb,cAAe,AACf,UAAY,CACb,AACD,4BACE,mBAAoB,AACpB,mBAAoB,AACpB,yCAAiD,AACjD,WAAe,AACf,yBAA0B,AAC1B,qBAAsB,AACtB,WAAa,CACd,AACD,yBACA,8BACI,YAAc,CACjB,CACA","file":"section-plan.vue","sourcesContent":["\n.section-plan[data-v-2429f830] {\n  background-image: linear-gradient(to bottom, #e7f0f4, #f8fbfc 68%);\n  font-size: 18px;\n  padding: 130px 4% 60px;\n}\n@media (max-width: 936px) {\n.section-plan[data-v-2429f830] {\n      padding: 45px 4%;\n}\n}\n.bold[data-v-2429f830] {\n  font-weight: 700;\n}\n.text-blue[data-v-2429f830] {\n  color: #005398;\n}\n.subtitle[data-v-2429f830] {\n  color: #494949;\n  font-size: 16px;\n  padding: 0 20%;\n  text-align: center;\n}\n@media (max-width: 936px) {\n.subtitle[data-v-2429f830] {\n      padding: 0 4%;\n}\n}\n.group-title[data-v-2429f830] {\n  border: 2px solid #005398;\n  border-radius: 15px;\n  color: #005398;\n  padding: 15px 0;\n  text-align: center;\n  margin: 0 auto;\n  width: 85%;\n}\n@media (max-width: 936px) {\n.group-title[data-v-2429f830] {\n      margin: 0 auto 17px auto;\n      width: 60%;\n}\n}\n.f-14[data-v-2429f830] {\n  font-size: 14px;\n}\n.text-price[data-v-2429f830] {\n  color: #f3b951;\n}\n.group-text[data-v-2429f830] {\n  background-color: #ffffff;\n  border: solid 3px #f2f6f7;\n  border-radius: 12px;\n  font-size: 14px;\n  height: calc(100% - 100px);\n  padding: 19px;\n}\n@media (max-width: 936px) {\n.group-text[data-v-2429f830] {\n      margin: 0 auto;\n      width: 80%;\n}\n}\n.text-number[data-v-2429f830] {\n  align-items: center;\n  background-color: #005398;\n  border-radius: 50%;\n  color: #ffffff;\n  display: flex;\n  font-size: 24px;\n  font-weight: 700;\n  justify-content: center;\n  height: 58px;\n  margin: 0 auto;\n  width: 58px;\n}\n.href-wssp[data-v-2429f830] {\n  background: #64b161;\n  border-radius: 26px;\n  box-shadow: 0 2px 6px 0 rgba(158, 158, 158, 0.5);\n  color: #ffffff;\n  padding: 9px 9px 9px 22px;\n  text-decoration: none;\n  width: 282px;\n}\n@media (max-width: 936px) {\n.group-arrow[data-v-2429f830] {\n    display: none;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 974:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"section-plan",attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","text-xs-center":"","mb-4":""}},[_c('img',{attrs:{"src":"/static/images-new/sections/logo-japi.svg","alt":"logo japi"}})]),_vm._v(" "),_c('v-flex',{staticClass:"subtitle",attrs:{"xs12":"","mb-5":""}},[_c('p',[_c('span',{staticClass:"bold text-blue"},[_vm._v("Japisale")]),_vm._v(" \n\t\t\tse renueva! En Alianza con "),_c('span',{staticClass:"bold"},[_vm._v("CasaMarket")]),_vm._v(" ofrece una solución integral para tu empresa: \n\t\t\t"),_c('span',{staticClass:"bold text-blue"},[_vm._v("Sistema de Gestión Integrado + Venta Online")])]),_vm._v(" "),_c('p',[_vm._v("Escala Tu Negocio con nuestros Productos de Gestión y Venta")])]),_vm._v(" "),_c('v-flex',[_c('v-layout',{staticClass:"group-arrow",attrs:{"justify-center":"","mb-2":""}},[_c('v-flex',{attrs:{"xs3":"","text-xs-center":""}},[_c('img',{attrs:{"src":"/static/images-new/sections/arrow-yellow.svg","alt":"flecha"}})]),_vm._v(" "),_c('v-flex',{attrs:{"xs3":"","text-xs-center":""}},[_c('img',{attrs:{"src":"/static/images-new/sections/arrow-yellow.svg","alt":"flecha"}})])],1),_vm._v(" "),_c('v-layout',{attrs:{"justify-center":"","wrap":""}},_vm._l((_vm.items),function(item){return _c('v-flex',{key:item.id,attrs:{"xs12":"","md3":"","px-3":"","mb-3":""}},[_c('div',{staticClass:"group-title mb-3"},[_c('p',{staticClass:"mb-2 f-14"},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('p',{staticClass:"mb-0 text-price bold"},[_vm._v(_vm._s(item.price))])]),_vm._v(" "),_c('div',{staticClass:"group-text"},[_c('div',{staticClass:"text-number mb-3"},[_vm._v(_vm._s(item.id))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(item.subtitle))]),_vm._v(" "),_c('div',_vm._l((item.list),function(list){return _c('div',{key:list,staticClass:"layout mb-2"},[_c('img',{staticClass:"mr-2",attrs:{"src":"/static/images-new/icons/check-orange.svg","alt":"check","height":"14px"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(list))])])}))])])}))],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","text-xs-center":"","mt-5":""}},[_c('a',{staticClass:"href-depressed",attrs:{"href":_vm.whatsappLink,"target":"_blank"}},[_c('button',{staticClass:"href-wssp w-bold"},[_c('v-layout',{attrs:{"align-center":""}},[_c('v-flex',{attrs:{"xs2":""}},[_c('img',{attrs:{"src":"/static/images-new/icons/whatsapp-white.svg","alt":""}})]),_vm._v(" "),_c('v-flex',{staticClass:"ml-1 text-wssp",attrs:{"text-xs-left":""}},[_vm._v("\n\t\t\t\t\t\tDeseo más información\n\t\t\t\t\t")])],1)],1)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 975:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section-plan'),_vm._v(" "),_c('company-data',{attrs:{"is-japi":""}}),_vm._v(" "),_c('app-footer',{attrs:{"is-japi":""}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/8.d4b165f7ec6ca273b0dc.js